import _typeof from "@babel/runtime/helpers/typeof";
import { UTM_PARAMS_KEY } from "../Constants/campaign";
import SessionStorageHelper from "./SessionStorageHelper";
export var getAcquisitionChannelTrackingValues = function getAcquisitionChannelTrackingValues() {
  var acqChannel = SessionStorageHelper.getItem(UTM_PARAMS_KEY);
  if (acqChannel) {
    var parsedAcqChannel = JSON.parse(acqChannel);
    if (parsedAcqChannel && _typeof(parsedAcqChannel) === 'object') {
      var adName = parsedAcqChannel.adName,
        channel = parsedAcqChannel.channel,
        type = parsedAcqChannel.type,
        campaignName = parsedAcqChannel.campaignName,
        mediumName = parsedAcqChannel.mediumName,
        keywordName = parsedAcqChannel.keywordName,
        termName = parsedAcqChannel.termName,
        content = parsedAcqChannel.content;
      return {
        acquisition_channel_ad_name: adName,
        acquisition_channel_group_name: channel,
        acquisition_channel_type_name: type,
        acquisition_channel_campaign_name: campaignName,
        acquisition_channel_medium_name: mediumName,
        acquisition_channel_keyword_name: keywordName,
        acquisition_channel_term_name: termName,
        acquisition_channel_content_name: content
      };
    }
  }
  return null;
};
export default {
  getAcquisitionChannelTrackingValues: getAcquisitionChannelTrackingValues
};